import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

import styles from "./discussions.module.scss";
import DiscussionItem from "./discussionItem";
import NewDiscussion from "../../common/components/newDiscussion/newDiscussion.component";
import DiscussionDetails from "../../common/components/discussionDetails";
import { appModelSettingSet } from "application/app.action";
import {
  discussionDelete,
  privateDiscussionsGet,
  publicDiscussionsGet,
  resetMsgsCount,
  setSelectedDiscussion,
} from "../../common/actions/discussions.action";
import { useQuery } from "../../common/helper";

const DiscussionsComponent = () => {
  const query = useQuery().get("type") || "GROUP";
  const dispatch = useDispatch();
  const {
    authReducer: { session },
    appReducer: { modalSetting },
    councilReducer: { selectedCouncil },
    discussionsReducer: {
      publicDiscussions,
      privateDiscussions,
      selectedDiscussion,
    },
  } = useSelector((state) => state);
  const [showDetailsWindow, setShowDetailsWindow] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  useEffect(() => {
    dispatch(resetMsgsCount());
  }, [])

  const getData = () => {
    if (query === "GROUP") {
      dispatch(
        publicDiscussionsGet({
          council_id: selectedCouncil.id,
          items: "",
          enqueueSnackbar,
        }),
      );
    }

    if (query === "PRIVATE") {
      dispatch(
        privateDiscussionsGet({ id: selectedCouncil.id, enqueueSnackbar }),
      );
    }
  };

  useEffect(() => {
    if (selectedCouncil?.id) {
      getData();
    }
  }, [selectedCouncil, query]);

  const redirectAfterSubmit = (value) => {
    history.push(`/discussions?type=${value}`)
  }

  const startNewDiscussion = () => {
    const customSettings = {
      title: `Start a New ${
        query === "GROUP" ? "Discussion" : "Private Discussion"
      }`,
      show: true,
      height: "300",
      width: "540",
      component: (
        <NewDiscussion type="Council" isPrivate={query === "PRIVATE"} handleRedirectTo={redirectAfterSubmit} />
      ),
    };
    dispatch(
      appModelSettingSet({
        ...modalSetting,
        ...customSettings,
      }),
    );
  };

  const handleShow = (details) => {
    dispatch(setSelectedDiscussion(details));

    setShowDetailsWindow(true);
  };

  const handleClose = () => {
    localStorage.removeItem("temporary_message");
    setShowDetailsWindow(false);
    dispatch(setSelectedDiscussion({}));
  };

  const handleOptionsClick = (val, discussion) => {
    if (val === 0) {
      const customSettings = {
        title: "Edit Discussion",
        show: true,
        height: "300",
        width: "540",
        component: (
          <NewDiscussion
            isPrivate={query === "PRIVATE"}
            discussion={discussion}
          />
        ),
      };

      dispatch(
        appModelSettingSet({
          ...modalSetting,
          ...customSettings,
        }),
      );
    }

    if (val === 1) {
      dispatch(discussionDelete(discussion))
    }
  };

  return (
    <section className={styles.pageWrp}>
      {showDetailsWindow && (
        <>
          <div className={styles.detailsExtraLayer}></div>
          <DiscussionDetails
            handleClose={handleClose}
            details={selectedDiscussion}
            query={query}
          />
        </>
      )}
      <div className={styles.pageHeader}>
        <div className="d-flex align-items-center">
          <span className={styles.title}>
            {query === "GROUP" ? "Public" : "Private"} Discussions
          </span>
          <div className={styles.viewChanger}>
            <Link
              to="/discussions?type=GROUP"
              className={query === "GROUP" ? styles.activeView : ""}
            >
              Public
            </Link>
            <Link
              to="/discussions?type=PRIVATE"
              className={query === "PRIVATE" ? styles.activeView : ""}
            >
              Private
            </Link>
          </div>
        </div>
        <div className={styles.newMsg} onClick={startNewDiscussion}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
          >
            <g fill="none" fillRule="evenodd">
              <g fill="#D1EEFC">
                <g>
                  <g>
                    <path
                      d="M7.314 0L7.314 7.314 0 7.314 0 8.686 7.314 8.686 7.314 16 8.686 16 8.686 8.686 16 8.686 16 7.314 8.686 7.314 8.686 0z"
                      transform="translate(-1219 -151) translate(1202.5 143) translate(17 8.5)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <span>New {query === "GROUP" ? "Discussion" : "Message"}</span>
        </div>
      </div>
      <div className={styles.discussionsList}>
        {query === "GROUP" ? (
          publicDiscussions?.length ? (
            publicDiscussions.map((discussion) => (
              <DiscussionItem
                key={discussion.id}
                discussion={discussion}
                handleShow={() => handleShow({
                  ...discussion,
                  prop: "publicDiscussions",
                })}
                session={session}
                handleOptionsClick={handleOptionsClick}
              />
            ))
          ) : (
            <div className={styles.noData}>
              {!publicDiscussions ? "Loading..." : "No group discussions yet!"}
            </div>
          )
        ) : privateDiscussions?.length ? (
          privateDiscussions.map((discussion) => (
            <DiscussionItem
              key={discussion.id}
              discussion={discussion}
              handleShow={() => handleShow({
                ...discussion,
                isPrivate: true,
                prop: "privateDiscussions",
              })}
              isPrivate
              session={session}
              handleOptionsClick={handleOptionsClick}
            />
          ))
        ) : (
          <div className={styles.noData}>
            {!privateDiscussions ? "Loading..." : "No private messages yet!"}
          </div>
        )}
      </div>
    </section>
  );
};

export default React.memo(DiscussionsComponent);
